import { atomWithStorage } from 'sierra-client/state/storage'
import { z } from 'zod'

export const previousInstructionsAtom = atomWithStorage('previous-instructions', [], z.string().array())
